import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Éditeur du site",
    body: [
      "Le site avelis.be est édité par DK Soins SRL, société de droit belge exploitant la marque AVELIS.",
      "Siège social : Route de Gosselies 27/8, 6220 Fleurus, Belgique",
      "Numéro d'entreprise (BCE) : 1008.815.935",
      "E-mail : contact@avelis.be",
      "Téléphone : +32 489 56 78 88",
    ],
  },
  {
    title: "Activité",
    body: [
      "AVELIS fournit des services de tarification et de facturation des soins infirmiers à domicile pour les infirmiers indépendants, les groupements et les sociétés infirmières en Belgique, principalement en Wallonie et à Bruxelles.",
    ],
  },
  {
    title: "Directeur de la publication",
    body: [
      "Le directeur de la publication est le représentant légal de DK Soins SRL.",
    ],
  },
  {
    title: "Hébergement",
    body: [
      "Le site est hébergé sur une infrastructure cloud professionnelle sécurisée. Les informations détaillées relatives à l'hébergeur sont disponibles sur simple demande à contact@avelis.be.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    body: [
      "L'ensemble des éléments constituant le site (textes, éléments graphiques, logo AVELIS, mise en page, structure) est la propriété exclusive de DK Soins SRL ou fait l'objet d'une autorisation d'utilisation.",
      "Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite et constitue une contrefaçon au sens du Code de droit économique belge.",
    ],
  },
  {
    title: "Limitation de responsabilité",
    body: [
      "Les informations publiées sur ce site sont fournies à titre général et indicatif. Elles ne constituent ni un conseil juridique, ni un conseil médical, ni une garantie de résultat.",
      "AVELIS ne valide pas médicalement les soins, ne garantit ni le remboursement ni l'acceptation d'une facturation par un organisme assureur, et ne peut pas régulariser une prestation non conforme. L'exactitude des prestations déclarées et le respect des règles de facturation restent de la responsabilité du professionnel de santé.",
      "DK Soins SRL ne peut être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder.",
    ],
  },
  {
    title: "Liens externes",
    body: [
      "Le site propose des liens vers des services tiers (notamment WhatsApp, service exploité par Meta). Ces services sont soumis à leurs propres conditions d'utilisation et politiques de confidentialité, que nous vous invitons à consulter.",
    ],
  },
  {
    title: "Droit applicable",
    body: [
      "Les présentes mentions légales sont soumises au droit belge. Tout litige relatif à l'utilisation du site relève de la compétence des tribunaux belges.",
    ],
  },
];

const MentionsLegales = () => (
  <>
    <Seo
      title="Mentions légales | AVELIS — DK Soins SRL"
      description="Mentions légales du site AVELIS, marque de DK Soins SRL — tarification infirmière en Belgique."
    />
    <section data-testid="legal-page" className="pt-[130px] sm:pt-[160px] pb-16 sm:pb-24 bg-[#f6f3ec]">
      <div className="container-avelis max-w-3xl">
        <Reveal>
          <p className="eyebrow"><span className="dot-sage" />Légal</p>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0d2731]">Mentions légales</h1>
          <p className="mt-5 text-sm text-[#4b585e]">Dernière mise à jour : octobre 2026</p>
          <div className="mt-10 space-y-10">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="text-xl font-extrabold tracking-tight text-[#0d2731]">{s.title}</h2>
                <div className="mt-3 space-y-2">
                  {s.body.map((p, i) => (
                    <p key={i} className="text-sm sm:text-base text-[#4b585e] leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default MentionsLegales;
